import { AxiosExcel } from "../../API/Axios";
import { fetchData } from "../GlobalService";
import { ExtractExcelFileData, ExtractExcelFileData1 } from "./ExcelFileData";

const UserId = localStorage.getItem("UserId")?.toString();
const EndPoint = {
  UploadExcelData: "UploadExcelData",
  GetExcelTemplate: "GetExcelTemplate",
  UploadExcelOffline : "UploadExcelOffline"
};
const ExcelUrl = "/ExcelUpload";
export const ExcelTemplateDownload = async (ProcessName: string) => {
  try {
    const res = await fetchData(
      ExcelUrl,
      EndPoint.GetExcelTemplate,
      `ProcessName=${ProcessName}`
    );
    const template = res.Data.columns.map((val:any)=>(
      {[val]:null}
  ));
    return template;
  } catch (err: any) {
    throw err;
  }
};
// interface excelUploadProps {
//   ProcessName:string;
//   ProcessParameters? : any;
//   FileContent : any;
// }
// interface excelUploadRes {
//   Status:string;
//   Message:string;
//   Data:any;
// }
// const [data,setData] = useState<excelUploadRes>();
export const ExcelUpload = async (
  ProcessName: string,
  ProcessParameters: any,
  FileContent: any,
  filetypes: string
) => {
  let fileTypesExcel = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];
  let fileTypesCSV = ["text/csv"];
  let fileTypesExcelCSV = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/csv",
  ];
  let filename_withextension = FileContent.name;
  let filename_withoutextension = filename_withextension.slice(
    0,
    filename_withextension.lastIndexOf(".")
  );
  let fileTypechk = false;
  if (filetypes === "CSV") {
    fileTypechk = fileTypesCSV.includes(FileContent.type);
  } else if (filetypes === "Excel") {
    fileTypechk = fileTypesExcel.includes(FileContent.type);
  } else {
    fileTypechk = fileTypesExcelCSV.includes(FileContent.type);
  }

  if (FileContent && fileTypechk) {
    let columns ;
    try {
      const res = await fetchData(
        ExcelUrl,
        EndPoint.GetExcelTemplate,
        `ProcessName=${ProcessName}`
      );
      columns = res.Data.columns
      }catch(error){
        console.log("ERROR",error)
      }
    const result = await ExtractExcelFileData1(FileContent);
    // const allHeaders = new Set();
    // result.headers.forEach((obj) => {
    //   Object.keys(obj).forEach((key) => allHeaders.add(key));
    // });
    // const uniqueKeys = Array.from(allHeaders);
    // let filesHeader = uniqueKeys.filter((item: any) => {
    //   if (item.indexOf("__") === -1) {
    //     return item;
    //   }
    // });
    let validFileCheck =
      JSON.stringify(columns) === JSON.stringify(result.headers);
    if (result.headers.length === 0) {
      let obj = {
        Status: "ErrorFR",
        Message: "Can't upload empty file",
        Data: null,
      };
      return obj;
    } else {
      if (validFileCheck) {
        const formFile = new FormData();
        formFile.append("ProcessName", ProcessName);
        formFile.append("UserId", UserId ?? "");
        formFile.append("FileName", filename_withoutextension);
        formFile.append("ProcessParameters", ProcessParameters);
        formFile.append("FileContent", FileContent);
        try {
          let response = await AxiosExcel.post(
            `${ExcelUrl}/${EndPoint.UploadExcelData}`,
            formFile,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          return response.data;
        } catch (err: any) {
          throw err;
        }
      } else {
        let obj = {
          Status: "ErrorFR",
          Message:"The file content is invalid.",
          Data: null,
        };
        return obj;
      }
    }
  } else {
    let obj = {
      Status: "ErrorFR",
      Message: `Please specify a valid file. Can upload only ${
        filetypes === "Excel" ? "Excel" : "CSV"
      } file`,
      Data: null,
    };
    return obj;
  }
};

export const ExcelUploadOffline = async (
  ProcessName: string,
  ProcessParameters: any,
  FileContent: any,
  filetypes: string
) => {
  let fileTypesExcel = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ];
  let fileTypesCSV = ["text/csv"];
  let fileTypesExcelCSV = [
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "text/csv",
  ];
  let filename_withextension = FileContent.name;
  let filename_withoutextension = filename_withextension.slice(
    0,
    filename_withextension.lastIndexOf(".")
  );
  let fileTypechk = false;
  if (filetypes === "CSV") {
    fileTypechk = fileTypesCSV.includes(FileContent.type);
  } else if (filetypes === "Excel") {
    fileTypechk = fileTypesExcel.includes(FileContent.type);
  } else {
    fileTypechk = fileTypesExcelCSV.includes(FileContent.type);
  }

  if (FileContent && fileTypechk) {
    let columns ;
    try {
      const res = await fetchData(
        ExcelUrl,
        EndPoint.GetExcelTemplate,
        `ProcessName=${ProcessName}`
      );
      columns = res.Data.columns
      }catch(error){
        console.log("ERROR",error)
      }
    const result = await ExtractExcelFileData1(FileContent);
    // const allHeaders = new Set();
    // result.headers.forEach((obj) => {
    //   Object.keys(obj).forEach((key) => allHeaders.add(key));
    // });
    // const uniqueKeys = Array.from(allHeaders);
    // let filesHeader = uniqueKeys.filter((item: any) => {
    //   if (item.indexOf("__") === -1) {
    //     return item;
    //   }
    // });
    let validFileCheck =
      JSON.stringify(columns) === JSON.stringify(result.headers);
    if (result.headers.length === 0) {
      let obj = {
        Status: "ErrorFR",
        Message: "Can't upload empty file",
        Data: null,
      };
      return obj;
    } else {
      if (validFileCheck) {
        const formFile = new FormData();
        formFile.append("ProcessName", ProcessName);
        formFile.append("UserId", UserId ?? "");
        formFile.append("FileName", filename_withoutextension);
        formFile.append("ProcessParameters", ProcessParameters);
        formFile.append("FileContent", FileContent);
        try {
          let response = await AxiosExcel.post(
            `${ExcelUrl}/${EndPoint.UploadExcelOffline}`,
            formFile,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
          return response.data;
        } catch (err: any) {
          throw err;
        }
      } else {
        let obj = {
          Status: "ErrorFR",
          Message:"The file content is invalid.",
          Data: null,
        };
        return obj;
      }
    }
  } else {
    let obj = {
      Status: "ErrorFR",
      Message: `Please specify a valid file. Can upload only ${
        filetypes === "Excel" ? "Excel" : "CSV"
      } file`,
      Data: null,
    };
    return obj;
  }
};
